import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import { CreditAgreementRoute } from './CreditAgreementRoute';
import { CreditAgreementsRoute } from './CreditAgreementsRoute';

export const CreditAgreementsRouter = () => {
  return (
    <Switch>
      <Route exact path="/credit-agreements">
        <CreditAgreementsRoute disableSelectors={false} />
      </Route>
      <Route
        exact
        path="/credit-agreements/:creditAgreementId"
        render={(props) => (
          <CreditAgreementRoute
            disableSelectors
            creditAgreementId={props.match.params.creditAgreementId}
          />
        )}
      />

      <Redirect to="/credit-agreements" />
    </Switch>
  );
};
